/**
 * Sanitize HTML to prevent XSS when using dangerouslySetInnerHTML.
 * Use for user-editable or database-sourced HTML (about sections, collection definitions, etc.)
 */
import DOMPurify from 'dompurify';

const ALLOWED_TAGS = [
  'p', 'br', 'strong', 'em', 'u', 's', 'a', 'ul', 'ol', 'li',
  'h1', 'h2', 'h3', 'h4', 'blockquote', 'div', 'span', 'img',
];

const ALLOWED_ATTR = ['href', 'src', 'alt', 'title', 'class'];

export function sanitizeHtml(dirty) {
  if (dirty == null || typeof dirty !== 'string') return '';
  return DOMPurify.sanitize(dirty, {
    ALLOWED_TAGS,
    ALLOWED_ATTR,
    ADD_ATTR: ['target'], // for external links
  });
}
